import React from "react";
import { Box, Typography } from "@mui/material";
import { CalendarOutlined } from "@ant-design/icons";
import { COLOR_PRIMARY } from "../../../../../libs/constants";

interface CardComponentPropsI {
  width: string;
  title: string;
  quantity: number;
  /** Texto del periodo seleccionado (ej. "Hoy", "Esta semana") */
  periodLabel: string;
  /** Color de acento de la tarjeta (hex) */
  color: string;
  icon?: React.ReactNode;
  value: string;
  total?: number;
}

export const CardComponent = React.memo(
  ({
    quantity,
    title,
    periodLabel,
    color,
    icon,
    value,
    total,
  }: CardComponentPropsI) => {
    return (
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          bgcolor: "#fff",
          borderRadius: 3,
          border: "1px solid #dde3ec",
          borderTop: `4px solid ${color}`,
          boxShadow: "0 2px 8px rgba(30, 58, 95, 0.10)",
          p: { xs: 1.5, sm: 2 },
          transition: "transform .25s ease, box-shadow .25s ease",
          "&:hover": {
            transform: "translateY(-3px)",
            boxShadow: "0 8px 20px rgba(30, 58, 95, 0.18)",
          },
        }}
      >
        {/* Circulo decorativo con el color del proceso */}
        <Box
          sx={{
            position: "absolute",
            top: -34,
            right: -34,
            width: 110,
            height: 110,
            borderRadius: "50%",
            bgcolor: `${color}14`,
            pointerEvents: "none",
          }}
        />
        <Box
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            gap: { xs: 1.25, sm: 1.75 },
          }}
        >
          <Box
            sx={{
              width: { xs: 44, sm: 56 },
              height: { xs: 44, sm: 56 },
              borderRadius: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              fontSize: { xs: 22, sm: 28 },
              color: "#fff",
              background: `linear-gradient(135deg, ${color} 0%, ${color}CC 100%)`,
              boxShadow: `0 4px 10px ${color}55`,
            }}
          >
            {icon}
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              noWrap
              sx={{
                fontSize: { xs: 11, sm: 12.5 },
                fontWeight: 700,
                letterSpacing: 0.6,
                textTransform: "uppercase",
                color: "text.secondary",
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: 28, sm: 36 },
                lineHeight: 1.1,
                fontWeight: 800,
                color: COLOR_PRIMARY,
              }}
            >
              {quantity}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            position: "relative",
            mt: 1.5,
            pt: 1.25,
            borderTop: "1px dashed #e1e6ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          {total ? (
            <Typography sx={{ fontWeight: 700, fontSize: 14, color }}>
              ${total}
            </Typography>
          ) : (
            <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
              <CalendarOutlined style={{ marginRight: 6 }} />
              Período
            </Typography>
          )}
          <Typography
            sx={{
              ml: "auto",
              px: 1.25,
              py: 0.25,
              borderRadius: 3,
              fontSize: 12,
              fontWeight: 700,
              color,
              bgcolor: `${color}1A`,
              whiteSpace: "nowrap",
            }}
          >
            {periodLabel}
          </Typography>
        </Box>
      </Box>
    );
  }
);
